import React from "react";
import StudentProfile from "./studentProfile/StudentProfile";

const ParentContentComponent = ({
  finishLoading,
  startLoading,
  studentRollNum,
  setUserId,
  setStudentProfileDetails,
  loader,
  LoaderPopUp,
  setParentTarget,
  parentUserId,

  // ⭐ REQUIRED PROPS
  setPaperId,
  setPlannerTestId,
  setPapers,
  setSinglePaper,
}) => {
  return (
    <>
      <StudentProfile
        finishLoading={finishLoading}
        startLoading={startLoading}
        studentRollNum={studentRollNum}
        setUserId={setUserId}
        setStudentProfileDetails={setStudentProfileDetails}
        setParentTarget={setParentTarget}
        loader={loader}
        LoaderPopUp={LoaderPopUp}
        parentUserId={parentUserId}

        // ⭐ PASS THESE 4 PROPERLY
        setPaperId={setPaperId}
        setPlannerTestId={setPlannerTestId}
        setPapers={setPapers}
        setSinglePaper={setSinglePaper}
      />
    </>
  );
};

export default ParentContentComponent;
